import SmartTable from "../../../global/components/table/table.vue";
import getTableApi from "../../../const/TableApis";
import WorkflowfolgestatusfunktionenModalCreate from "../WorkflowfolgestatusfunktionenModalCreate/WorkflowfolgestatusfunktionenModalCreate.vue";
import PageTabTitle from "../../../global/components/PageTabTitle/PageTabTitle.vue";

const TABLE_ID = "workflowfolgestatusfunktion";

// @vue/component
export default {
  name: "WorkflowfolgestatusfunktionenList",
  components: {
    SmartTable,
    WorkflowfolgestatusfunktionenModalCreate,
    PageTabTitle,
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }),
        rowActions: [
          {
            label: this.$gettext("Details anzeigen"),
            route: "root.workflowfolgestatusfunktionen.detail",
            routeParameters: [{ routeId: "id", rowPath: "pk" }],
          },
        ],
        actions: [
          {
            label: this.$gettext("Neue Statusfunktion erstellen"),
            callback: () => this.modal.create = true,
            permission: "statusfunktion.create",
            type: "button",
            className: "btn btn-primary",
            icon: "glyphicon-plus",
            htmlId: "statusfunktion_create",
          },
        ],
        label: "Statusfunktionen",
        pagination: true,
        details: false,
        view: {
          filter: "top",
        },
      },
      modal: {
        create: undefined,
      },
    };
  },
  methods: {
    closeModalCreate() {
      this.modal.create = false;
    },
  },
};
